import React from 'react';
import { Link } from 'react-router-dom';

/**
 * CockpitControlDetail - name/description/positions/used-in/tip card for
 * the currently selected control. Shared by the full Explorer page, the
 * embedded locate panel, and the mobile bottom sheet.
 */
export const CockpitControlDetail = (props) => {
  const control = props.control;
  const slugByTitle = props.slugByTitle || {};

  if (!control) {
    return (
      <section
        className="rounded-gc-card border p-4 flex items-center justify-center min-h-[96px]"
        style={{ background: 'var(--gc-card)', borderColor: 'var(--gc-border-card)' }}
        data-testid="cockpit-control-detail-empty"
      >
        <p className="text-sm text-center m-0" style={{ color: '#8A97AB' }}>
          Tap a marker to see what it does.
        </p>
      </section>
    );
  }

  return (
    <section
      className="rounded-gc-card border p-4 flex flex-col gap-3"
      style={{ background: 'var(--gc-card)', borderColor: 'var(--gc-border-card)' }}
      data-testid="cockpit-control-detail"
    >
      <h2
        className="font-barlow-condensed font-bold text-[22px] leading-tight m-0"
        style={{ color: 'var(--gc-text-main)' }}
        data-testid="cockpit-control-name"
      >
        {control.name}
      </h2>
      <p className="text-[15px] leading-relaxed m-0" style={{ color: 'var(--gc-text-body)' }}>
        {control.description}
      </p>

      {control.positions && control.positions.length > 0 && (
        <div className="flex gap-1.5 flex-wrap" data-testid="cockpit-control-positions">
          {control.positions.map((pos) => (
            <span
              key={pos}
              className="font-plex-mono text-xs font-semibold rounded-md px-2 py-1 border"
              style={{ color: 'var(--gc-cyan)', borderColor: '#1F4A57', background: 'var(--gc-current-row)' }}
            >
              {pos}
            </span>
          ))}
        </div>
      )}

      {control.phases && control.phases.length > 0 && (
        <div className="flex gap-1.5 flex-wrap items-center" data-testid="cockpit-control-used-in">
          <span
            className="font-plex-mono text-[10px] font-semibold tracking-[0.1em] mr-0.5"
            style={{ color: 'var(--gc-text-muted)' }}
          >
            USED IN
          </span>
          {control.phases.map((phaseTitle) => {
            const slug = slugByTitle[phaseTitle];
            const chip = (
              <span
                className="font-barlow-condensed font-semibold text-[15px] rounded-md px-2.5 py-1 border"
                style={{ color: 'var(--gc-text-main)', background: 'var(--gc-checklist-card)', borderColor: 'var(--gc-border-card)' }}
              >
                {phaseTitle}
              </span>
            );
            return slug ? (
              <Link key={phaseTitle} to={`/phases/${slug}`} className="no-underline" data-testid={`cockpit-used-in-${slug}`}>
                {chip}
              </Link>
            ) : (
              <span key={phaseTitle}>{chip}</span>
            );
          })}
        </div>
      )}

      {control.tip && (
        <div
          className="rounded-gc-card border p-3 flex flex-col gap-1"
          style={{ background: '#17130A', borderColor: '#3A2E14' }}
          data-testid="cockpit-control-tip"
        >
          <div
            className="font-plex-mono text-[11px] font-semibold tracking-[0.08em]"
            style={{ color: 'var(--gc-amber)' }}
          >
            FENIX TIP
          </div>
          <div className="text-sm leading-relaxed" style={{ color: '#E2D6BE' }}>
            {control.tip}
          </div>
        </div>
      )}
    </section>
  );
};

export default CockpitControlDetail;
